import React from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";
import { StaticImage } from "gatsby-plugin-image";

// styles
import * as styles from "./JoinBanner.module.css";

const propTypes = {
  title: PropTypes.string,
};

const defaultProps = {
  title:
    "Join a team where your skills, passion, and purpose align to create a healthier, happier future for millions.",
};

const JoinBanner = ({ title }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className={styles.joinBannerWrapper}>
      <div
        className={`${styles.bannerContainer} scroll_animate ${
          inView && "inview"
        }`}
        ref={ref}
      >
        {/* Desktop Image */}
        <StaticImage
          src="../../../images/career/join-banner-desk.png"
          alt="Join Twin Health Team"
          className={styles.bannerImageDesktop}
          placeholder="blurred"
          quality={100}
          layout="fullWidth"
          objectFit="cover"
          objectPosition="center"
        />

        {/* Mobile Image */}
        <StaticImage
          src="../../../images/career/join-banner-mob.png"
          alt="Join Twin Health Team"
          className={styles.bannerImageMobile}
          placeholder="blurred"
          quality={100}
          layout="fullWidth"
          objectFit="cover"
          objectPosition="center"
        />

        {/* Overlay Content */}
        <div className={styles.overlayContent}>
          <div className={styles.textBox}>
            <h2 className={styles.title}>{title}</h2>
          </div>
        </div>
      </div>
    </section>
  );
};

JoinBanner.propTypes = propTypes;
JoinBanner.defaultProps = defaultProps;

export default JoinBanner;
